import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { DateRangePickerComponent } from '../worklist/date-range-picker/date-range-picker.component';
import { DataTableComponent } from '../worklist/data-table/data-table.component';
import { DetailsComponent } from '../worklist/details/details.component';
import { FiltersComponent } from '../worklist/worklist-filters/worklist-filters.component';
import { AppCommonModule } from '../app-common/app-common.module';
import { KeywordSearchComponent } from '../worklist/keyword-search/keyword-search.component';
import { PriorsComponent } from '../worklist/details/priors/priors.component';
import { WorklistComponent } from '../worklist/worklist.component';
import { ReferralsComponent } from '../referrals/referrals.component';
import { DashboardComponent } from './dashboard.component';
import { ReferralTableComponent } from '../referrals/referral-table/referral-table.component';
import { MultilineBodyPartComponent } from '../referrals/multiline-bodypart/multiline-bodypart.component';
import { ViewReferralComponent } from '../referrals/view-referral/view-referral.component';
import { DialogViewReferralConfirmationComponent } from '../referrals/dialog-view-referral-confirmation/dialog-view-referral-confirmation.component';
import { ReferralFiltersComponent } from '../referrals/referral-filters/referral-filters.component';
import { ClinicalFeedbackModule } from '@app/clinical-feedback/clinical-feedback.module';
import { ScanDocsComponent } from '@app/worklist/details/scan-docs/scan-docs.component';
import { SharedModule } from '@app/shared/shared.module';
import { ImagingRequestsModule } from '@app/imaging-requests/imaging-requests.module';
import { DetailsInputComponent } from '@app/worklist/details-input/details-input.component';
import { DetailsTextAreaComponent } from '@app/worklist/details-text-area/details-text-area.component';

@NgModule({
    declarations: [
        DashboardComponent,
        WorklistComponent,
        DataTableComponent,
        DetailsComponent,
        ScanDocsComponent,
        FiltersComponent,
        DateRangePickerComponent,
        KeywordSearchComponent,
        PriorsComponent,
        ReferralsComponent,
        ReferralTableComponent,
        MultilineBodyPartComponent,
        DialogViewReferralConfirmationComponent,
        ViewReferralComponent,
        ReferralFiltersComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        AppCommonModule,
        ClinicalFeedbackModule,
        SharedModule,
        ImagingRequestsModule,
        DetailsInputComponent,
        DetailsTextAreaComponent
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class DashboardModule {}
